module.exports = __webpack_public_path__ + "img/sHotSmash_350x350.cdf16400.jpg";